import React, { PureComponent } from 'react';
import { dispatch } from '@ro-store/index';
import { Cell, HeadRow } from '../../../RoTable';
import { Box } from '@rebass/grid';
import CloseIcon from '@material-ui/icons/Close';
import { CloseButton, TooltipName } from '../../RoTooltip.styles';
import { TableHead, TableBody } from '@material-ui/core';
import { FavoriteLocation } from '../';
import { FavoriteLocation as FavoriteLocationProps } from '@ro-atoms/RoTooltip/RoTooltip.types';
import { CurrentLocation } from '@ro-atoms/RoTooltip/RoTooltip.types';

type Props = {
  text?: string;
  currentLocation: CurrentLocation;
  onShowSnack: Function;
  favoriteList: FavoriteLocationProps[];
};

type State = {
  locationName: string;
};

export class TooltipHeader extends PureComponent<Props, State> {
  state: State = {
    locationName: ''
  };
  setFavoriteLocation = () =>
    dispatch.ro.addFavoriteLocation({
      location: this.props.currentLocation,
      name: this.state.locationName || this.props.text
    });

  setTitle = (val: string) => {
    this.setState({ locationName: val });
  };

  onFavoriteList = (hdms?: string) => this.props.favoriteList.filter(item => item.location.hdms === hdms)[0];

  findNameOnFavorite = (name: string) => this.props.favoriteList.filter(item => item.name === name)[0];

  onClose = () => dispatch.ro.setCurrentLocation({});

  render() {
    const onFavoriteList = this.onFavoriteList(this.props.currentLocation.hdms);
    return (
      <>
        <TableHead>
          <HeadRow clickable>
            <Cell colSpan={2}>
              <Box pr={20}>
                <TooltipName>{onFavoriteList?.name || this.props.text}</TooltipName>
              </Box>
              <CloseButton onClick={this.onClose}>
                <CloseIcon />
              </CloseButton>
            </Cell>
          </HeadRow>
        </TableHead>
        <TableBody>
          {!onFavoriteList && (
            <FavoriteLocation
              locationName={this.state.locationName}
              setTitle={this.setTitle}
              onShowSnack={this.props.onShowSnack}
              setFavoriteLocation={this.setFavoriteLocation}
              findNameOnFavorite={this.findNameOnFavorite}
            />
          )}
        </TableBody>
      </>
    );
  }
}
